const REVEAL_SELECTOR = '.js-scroll-reveal';
const ACTIVE_CLASS = 'is-in-view';
const ROOT_MARGIN = '0px 0px -10% 0px';
const THRESHOLD = 0.1;

export default class ScrollReveal {
  revealAll = (elements) => {
    elements.forEach((el) => el.classList.add(ACTIVE_CLASS));
  };

  initialize = () => {
    const elements = document.querySelectorAll(REVEAL_SELECTOR);

    if (!elements.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      this.revealAll(elements);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(ACTIVE_CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: ROOT_MARGIN, threshold: THRESHOLD });

    elements.forEach((el) => observer.observe(el));
  };
}
